import HigiaStorageSevice from './higia-storage.service'
class HigiaComunicationSevice {
    public sendPostMessageFromSonToFather = (message: any, key?: any, isObj?: boolean) => {
        const higiaStorageSevice = new HigiaStorageSevice()
        if (key) {
            isObj ? higiaStorageSevice.set(key, message, isObj) : higiaStorageSevice.set(key, message)
        }
    }

    public convertObjQueryStringArr = (obj: any) => {
        const str: Array<any> = []
        for (const p in obj) {
            // eslint-disable-next-line no-prototype-builtins
            if (obj.hasOwnProperty(p)) {
                encodeURIComponent(p)
                str.push(encodeURIComponent(p) + '=' + encodeURIComponent(obj[p]))
            }
        }
        return str.length > 0 ? '?' + str.join('&') : ''
    }
}

const HCommunicationService = new HigiaComunicationSevice()
export { HigiaComunicationSevice, HCommunicationService }
export default HigiaComunicationSevice
